import React, { useRef } from "react";
import "./LogosScroll.css";

const ScrollingLogos = ({ gradientColor, variant } = {}) => {
  const logos = [
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/LIBAS_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/DOT_N_KEY_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/LITTLEBOX_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/FLIPKART_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/NEW_ME_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/H&M_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/SANFE_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/AJIO_LOGO.webp",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/BERRYLUSH_LOGO.webp",
  ];
  const logos2 = [
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/mars_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/chemist_at_play_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/dr_sheths_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/myntra_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/meesho_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/soch_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/powerlook_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/vero_modo_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/sun_scoop_logo.png",
  ];
  const logos3 = [
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/savana_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/urbanic_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/tokyo_talkies_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/nykaa_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/shopsy_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/innovist_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/snitch_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/foxtale_logo.png",
    "https://images.wishlink.com/alabaster/brand_dashboard/login_page_logos/uptownie_logo.png",
  ];

  const logoGroups = [logos, logos2, logos3];
  const columnRefs = useRef([]);

  const config = {
    columns: {
      default: 6,
      xl: 8,
      lg: 4,
      md: 3,
      sm: 2,
      xs: 1,
    },
    logoSize: {
      default: { width: 80, height: 90 },
      xl: { width: 90, height: 100 },
      lg: { width: 80, height: 90 },
      md: { width: 70, height: 80 },
      sm: { width: 60, height: 70 },
    },
    speeds: ["40s", "25s"],
  };
  return (
    <div
      className={`logos-scroll-container ${variant ? `logos-scroll-${variant}` : ""}`.trim()}
      style={
        gradientColor ? { "--logo-scroll-gradient": gradientColor } : undefined
      }
    >
      <div className="vertical-line" />
      <div className="columns-container">
        {[...Array(config.columns.default)].map((_, i) => {
          const groupIndex = i % logoGroups.length;
          const currentLogos = logoGroups[groupIndex];
          return (
            <div
              className={`scroll-column ${i % 2 ? "tall" : "short"}`}
              key={i}
              style={{
                "--speed": config.speeds[i % 2],
                "--logo-width": `${config.logoSize.default.width}px`,
                "--logo-height": `${config.logoSize.default.height}px`,
              }}
            >
              <div
                className="logos-column"
                onMouseEnter={(e) => {
                  const animations = e.currentTarget.getAnimations();
                  if (animations.length > 0) {
                    const animation = animations[0];
                    animation.pause();
                    columnRefs.current[i] = { animation };
                  }
                }}
                onWheel={(e) => {
                  e.preventDefault();
                  const stored = columnRefs.current[i];
                  if (stored?.animation) {
                    const delta = e.deltaY * 2;
                    const newTime = stored.animation.currentTime - delta;
                    const duration =
                      stored.animation.effect.getTiming().duration;
                    stored.animation.currentTime = Math.max(
                      0,
                      Math.min(newTime, duration),
                    );
                  }
                }}
                onTouchStart={(e) => {
                  const touch = e.touches[0];
                  columnRefs.current[i] = {
                    ...columnRefs.current[i],
                    touchY: touch.clientY,
                  };
                }}
                onTouchMove={(e) => {
                  e.preventDefault();
                  const touch = e.touches[0];
                  const stored = columnRefs.current[i];
                  if (stored?.animation) {
                    const delta = stored.touchY - touch.clientY;
                    const newTime = stored.animation.currentTime + delta * 4;
                    const duration =
                      stored.animation.effect.getTiming().duration;
                    stored.animation.currentTime = Math.max(
                      0,
                      Math.min(newTime, duration),
                    );
                    columnRefs.current[i].touchY = touch.clientY;
                  }
                }}
                onMouseLeave={() => {
                  const stored = columnRefs.current[i];
                  if (stored?.animation) {
                    stored.animation.play();
                  }
                }}
              >
                {[...currentLogos, ...currentLogos].map((logo, j) => (
                  <div className="logo-item" key={j}>
                    <img src={logo} alt="brand logo" />
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ScrollingLogos;
